import { helper } from '@ember/component/helper';

import { set } from 'rise-ui/utils/object.js';

export default helper(function setHelper(args) {
  return (...moreArgs) => {
    const [ obj, key, value ] = [ ...args, ...moreArgs ];
    obj && set(obj, key, value);
    return '';
  };
});
